import { Fraga } from "@/types/riskbedomning";

export const planeringsriskerFragor: Fraga[] = [
  {
    id: "transport-material-sammansatt",
    text: "Kan brister i utformning, bärighet eller bredd på transportvägar leda till olyckor, skador på material eller hinder i logistiken?",
    kategori: "Planering & projektering",
    fas: "byggskede",
    followUpQuestions: [
      "Riskerar transport och lossning av farliga material att ske utan tillräckliga skyddsåtgärder?",
      "Finns det risk att material behöver lagras på ett sätt som skapar säkerhetsrisker?",
      "Saknas det lyftöglor på godset/utrustningen som skall transporteras?",
      "Saknas det en riskanalys av transportvägarna till och inom byggarbetsplatsen?",
      "Kan bristande kontroll, skyltning eller uppföljning leda till att transportörer inte respekterar hastighetsgränser och säkerhetsregler på arbetsplatsen?",
      "Krävs särskild lyftanordning?",
      "Kan bristande kommunikation eller otydliga rutiner göra att entreprenörer och personal inte känner till gällande regler för transporter, leveranser och flöden på byggarbetsplatsen?",
      "Riskerar ändringar i logistikplanen att inte nå alla berörda parter?"
    ],
    afsReferences: ["AFS 2023:3", "AFS 2023:13"]
  },
  {
    id: "flaskhalsar-samordning",
    text: "Kan bristande samordning eller kommunikation mellan olika yrkesgrupper och entreprenörer leda till kollisioner, förseningar eller säkerhetsrisker?",
    kategori: "Planering & projektering", 
    fas: "byggskede",
    followUpQuestions: [
      "Kan bristande planering eller kommunikation mellan arbetsmoment som är beroende av varandra leda till kollisioner, förseningar eller riskfyllda situationer?",
      "Finns det risk att installationsutrymmen blockeras under byggskedet?",
      "Har arbetsordningen samordnats mellan olika yrkesgrupper?",
      "Riskerar montageordningen att sakna tydlig dokumentation och kommunikation?"
    ],
    afsReferences: ["AFS 2023:3", "AFS 2023:13"]
  },
  {
    id: "ergonomi-montage-sammansatt",
    text: "Kan bristande planering eller anpassning av ergonomi, montage eller prefabricerade komponenter skapa risker för belastningsskador, felmontering eller olyckor?",
    kategori: "Planering & projektering",
    fas: "byggskede", 
    followUpQuestions: [
      "Kan bristande planering eller arbetsutrymme göra att arbetsmoment måste utföras i obekväma eller belastande ställningar?",
      "Krävs specialverktyg för att minska belastning på personalen?",
      "Riskerar tunga lyft att utföras utan tillräckliga hjälpmedel eller säkerhetsrutiner?",
      "Finns det risk att installationsutrymmen blockeras under byggskedet?",
      "Har arbetsordningen samordnats mellan olika yrkesgrupper?",
      "Riskerar montageordningen att sakna tydlig dokumentation och kommunikation?",
      "Kan bristande planering eller kommunikation mellan arbetsmoment som är beroende av varandra leda till kollisioner, förseningar eller riskfyllda situationer?",
      "Kan vissa arbetsmoment flyttas till en säkrare miljö genom prefabricering?",
      "Kan bristande planering av transporter och logistik i samband med prefabricering leda till trängsel, kollisioner eller förseningar på arbetsplatsen?",
      "Riskerar hantering av prefabricerade element att skapa nya, oidentifierade risker?",
      "Kan bristande kontroll, dokumentation eller kommunikation vid montage av prefabricerade enheter leda till felmontering, instabilitet eller olycksrisker?"
    ],
    afsReferences: ["AFS 2023:13"]
  },
  {
    id: "stabilitet-haveri",
    text: "Finns det risk för otillräcklig stabilitet under byggskedet eller haveri i arbetsutrustning?",
    kategori: "Planering & projektering",
    fas: "byggskede",
    followUpQuestions: [
      "Kan brister i planering, dimensionering eller kontroll av temporära stöd samt förändrade markförhållanden leda till instabilitet, sättningar eller ras under byggtiden?",
      "Kan vind, regn, kyla eller snö påverka stabiliteten hos temporära konstruktioner, material eller mark under byggskedet om åtgärder inte planeras i förväg?",
      "Finns det risk för stillastående fordon eller maskiner på kritiska transportvägar?",
      "Kan brist på utbildning eller övning göra att personalen inte vet hur de ska agera vid ett haveri, ras eller annan kritisk händelse?",
      "Kan brist på tydliga rutiner för inspektion och underhåll av arbetsutrustning leda till att defekter eller säkerhetsbrister inte upptäcks i tid?",
      "Kan avsaknad av fungerande backupsystem vid kritiska moment leda till driftstopp, informationsförlust eller säkerhetsrisker?"
    ],
    afsReferences: ["AFS 2023:3", "AFS 2023:13"]
  }
];